// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { POINTS_HISTORY_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import { getDynamicLabelValues } from '../../../../../../../utils/labels/labelUtilty';

const getState = (state) => state[POINTS_HISTORY_REDUCER_KEY];

export const getPointHistoryState = (state) => {
  return state.pointHistoryReducer?.get('pointsHistoryData');
};

export const getPointHistoryRichTextContentId = () => {
  let pointHistoryRichTextContentId;
  const referredLabels = getDynamicLabelValues('global.placeRewards.referred');
  if (referredLabels && Array.isArray(referredLabels)) {
    referredLabels.forEach((label) => {
      if (label.name === 'Point History Content') pointHistoryRichTextContentId = label.contentId;
    });
  }
  return pointHistoryRichTextContentId;
};

export const getPointHistoryRichTextSelector = (state) => {
  return state.pointHistoryReducer?.get('pointsHistoryRichText');
};

export const getPointHistoryDataFetchingState = createSelector(
  getState,
  (state) => state && state.get('isFetching')
);
